import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { MongodbAtlasAiAccesses } from "./accesses.ts";
import { MongodbAtlasAiComponents } from "./components.ts";
import { MongodbAtlasIconUrl } from "./icon.ts";

const MongodbAtlasAiFilters = {
  project: { keys: ["name"] },
  // Rule filter values compile to regular expressions, so rules can scope by
  // role family ("GROUP_DATA_ACCESS_.*") or exactly
  // ("GROUP_DATA_ACCESS_READ_ONLY").
  policy: { keys: ["name"] },
} as const satisfies AnyFilterSchema;
export type MongodbAtlasAiFilters = typeof MongodbAtlasAiFilters;

export const MongodbAtlasAiRegistration = Registration({
  accesses: MongodbAtlasAiAccesses,
  category: "resource",
  components: MongodbAtlasAiComponents,
  docs: {
    install: "agentic-gateway/mcp-server/mongodb-atlas",
    request: "agentic-gateway/requesting-access",
  },
  filters: MongodbAtlasAiFilters,
  itemKind: "Project",
  label: "MongoDB Atlas",
  logoUrl: MongodbAtlasIconUrl,
  maturity: "beta",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "credential" }],
});

registerIntegration("mongodb-atlas-ai", MongodbAtlasAiRegistration);
